(function () {
  function init(root) {
    if (!root || root.dataset.dmHeaderReady === 'true') return;
    root.dataset.dmHeaderReady = 'true';

    var onScroll = function () {
      root.classList.toggle('is-scrolled', window.scrollY > 24);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    var toggle = root.querySelector('[data-dm-header-toggle]');
    var panel = root.querySelector('[data-dm-header-panel]');
    if (!toggle || !panel) return;

    var setOpen = function (open) {
      root.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.documentElement.classList.toggle('dm-nav-open', open);
    };

    setOpen(false);

    toggle.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      setOpen(!root.classList.contains('is-open'));
    });

    panel.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        setOpen(false);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && root.classList.contains('is-open')) {
        setOpen(false);
        toggle.focus();
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-dm-header]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector('[data-dm-header]');
    if (root) init(root);
  });
})();
